import * as Types from '../../../types/generated-gql';

import { gql } from '@apollo/client';
export type ZendeskBookingTripFragment = { __typename?: 'BookingTrip', _id: string, status: Types.TripStatus, timingStatus: Types.TripTimingStatus, hasEmergencyContacts: boolean, hasSignedTerms: boolean, termsAcceptedAt?: string | null, isLandOnly: boolean, isOpen: boolean, businessCode?: Types.BusinessCode | null, currencyCode: Types.CurrencyCode, customerId?: string | null, customerType: Types.TripCustomerType, requestedRoommates?: Array<string> | null, customer?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null, isVip: boolean, loyaltyLevel?: { __typename?: 'LoyaltyLevel', businessCode: Types.BusinessCode, content?: { __typename?: 'LoyaltyLevelContent', name?: string | null } | null } | null, loyaltyLevels?: Array<{ __typename?: 'LoyaltyLevel', businessCode: Types.BusinessCode, nbConfirmedLoyaltyTrips: number }> | null } | null, departure?: { __typename?: 'Departure', _id: string, departureDate: any, tourCode: string, status: Types.DepartureStatus, endDate: any, finalPaymentDeadline: any, prodTourId?: number | null, salesTourId: string, activeExtension?: { __typename?: 'DepartureExtension', _id: string, departureDate: any, endDate: any, tourExtension?: { __typename?: 'TourExtension', internalName: string } | null } | null, tourContent?: { __typename?: 'TourContent', name?: string | null, accommodations: Array<{ __typename?: 'TourAccommodationContent', name?: string | null }> } | null, rooms: Array<{ __typename?: 'DepartureRoom', _id: string, lineItemCode: any, cabinCode?: any | null, bed: { __typename?: 'TourBed', name: string, code: Types.TourBedCode } }> } | null, booking?: { __typename?: 'Booking', _id: string, balance: { __typename?: 'Money', value: number }, gcDeparture?: { __typename?: 'GCDeparture', _id: string, groupCoordinator?: { __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null, tsaInformation?: { __typename?: 'TSAInformation', dateOfBirth?: any | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, suffix?: string | null, expirationDate?: any | null, gender?: Types.TsaGender | null, issueDate?: any | null, countryOfIssue?: string | null, maskedIdentityDocumentNumber?: string | null } | null, lineItems: Array<{ __typename?: 'AdjustmentLineItem' } | { __typename?: 'ExtendedStayLineItem' } | { __typename?: 'FeeLineItem' } | { __typename?: 'FlightPackageLineItem' } | { __typename?: 'FlightShopLineItem' } | { __typename?: 'InsuranceAddonLineItem' } | { __typename?: 'InsuranceExtensionLineItem' } | { __typename?: 'InsuranceLineItem' } | { __typename?: 'PrivateGroupLineItem' } | { __typename?: 'PromoLineItem' } | { __typename?: 'TourAirportTransferLineItem' } | { __typename?: 'TourExcursionLineItem' } | { __typename?: 'TourExtensionLineItem', _id: string, departureDate: any, endDate: any, status: Types.LineItemStatus, type: Types.TripComponentType, departureExtensionId: string, cancellationDate?: any | null } | { __typename?: 'TourLineItem' } | { __typename?: 'TourRoomLineItem' }>, openExtensionLineItem?: { __typename?: 'TourExtensionLineItem', _id: string, departureDate: any, endDate: any, status: Types.LineItemStatus, departureExtensionId: string } | null, openDepartingFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, type: Types.TripComponentType, flightType: Types.FlightType, arrivalGatewayCode: string, departureDate: any, departureGatewayCode: string } | null, openReturningFlightLineItem?: { __typename?: 'FlightPackageLineItem', _id: string, type: Types.TripComponentType, flightType: Types.FlightType, arrivalGatewayCode: string, departureDate: any, departureGatewayCode: string } | null, openRoomLineItem?: { __typename?: 'TourRoomLineItem', lineItemCode: any, roommate?: { __typename?: 'Roommate', roommateId: string } | null } | null, openPreStayLineItem?: { __typename?: 'ExtendedStayLineItem', _id: string, departureDate: any, endDate: any, cityGateway?: { __typename?: 'Gateway', name: string } | null } | null, openPostStayLineItem?: { __typename?: 'ExtendedStayLineItem', _id: string, departureDate: any, endDate: any, cityGateway?: { __typename?: 'Gateway', name: string } | null } | null, roommates?: Array<{ __typename?: 'Customer', _id: string, firstName?: string | null, lastName?: string | null }> | null, flights?: { __typename?: 'TripFlights', _id: string, departingFlights: Array<{ __typename?: 'TripFlightSegment', departsAtLocalTime: string, departureGatewayCode: string, arrivalGatewayCode: string, arrivesAtLocalTime: string, flightNumber: string, pnrLocator: string, carrier?: { __typename?: 'Airline', name: string } | null }> } | null, healthNotesChecklistItem?: { __typename?: 'HealthNotesChecklistItem', isCompleted: boolean } | null, emergencyContactChecklistItem?: { __typename?: 'EmergencyContactChecklistItem', isCompleted: boolean } | null, travelerNotes?: { __typename?: 'TravelerNotes', dietaryNotes?: { __typename?: 'TravelerNote', text?: string | null } | null, medicalNotes?: { __typename?: 'TravelerNote', text?: string | null } | null, mobilityNotes?: { __typename?: 'TravelerNote', text?: string | null } | null } | null };

export const ZendeskBookingTripFragmentDoc = gql`
    fragment ZendeskBookingTrip on BookingTrip {
  _id
  status
  timingStatus
  hasEmergencyContacts
  hasSignedTerms
  termsAcceptedAt
  isLandOnly
  isOpen
  businessCode
  currencyCode
  customerId
  customerType
  customer {
    _id
    firstName
    lastName
    isVip
    loyaltyLevel(businessCode: $businessCode) {
      content(language: "default") {
        name
      }
      businessCode
    }
    loyaltyLevels {
      businessCode
      nbConfirmedLoyaltyTrips
    }
  }
  departure {
    _id
    departureDate
    tourCode
    status
    endDate
    finalPaymentDeadline
    prodTourId
    salesTourId
    activeExtension {
      _id
      departureDate
      endDate
      tourExtension {
        internalName
      }
    }
    tourContent(language: "default") {
      name
      accommodations {
        name
      }
    }
    rooms {
      _id
      lineItemCode
      cabinCode
      bed {
        name
        code
      }
    }
  }
  booking {
    _id
    balance {
      value
    }
    gcDeparture {
      _id
      groupCoordinator {
        _id
        firstName
        lastName
      }
    }
  }
  tsaInformation {
    dateOfBirth
    firstName
    lastName
    middleName
    suffix
    expirationDate
    gender
    issueDate
    countryOfIssue
    maskedIdentityDocumentNumber
  }
  lineItems {
    ... on TourExtensionLineItem {
      _id
      departureDate
      endDate
      status
      type
      departureExtensionId
      cancellationDate
    }
  }
  openExtensionLineItem {
    _id
    departureDate
    endDate
    status
    departureExtensionId
  }
  openDepartingFlightLineItem {
    _id
    type
    flightType
    arrivalGatewayCode
    departureDate
    departureGatewayCode
  }
  openReturningFlightLineItem {
    _id
    type
    flightType
    arrivalGatewayCode
    departureDate
    departureGatewayCode
  }
  openRoomLineItem {
    lineItemCode
    roommate {
      roommateId
    }
  }
  openPreStayLineItem {
    _id
    departureDate
    endDate
    cityGateway {
      name
    }
  }
  openPostStayLineItem {
    _id
    departureDate
    endDate
    cityGateway {
      name
    }
  }
  roommates {
    _id
    firstName
    lastName
  }
  flights {
    _id
    departingFlights {
      departsAtLocalTime
      departureGatewayCode
      arrivalGatewayCode
      arrivesAtLocalTime
      flightNumber
      pnrLocator
      carrier {
        name
      }
    }
  }
  healthNotesChecklistItem {
    isCompleted
  }
  emergencyContactChecklistItem {
    isCompleted
  }
  travelerNotes {
    dietaryNotes {
      text
    }
    medicalNotes {
      text
    }
    mobilityNotes {
      text
    }
  }
  requestedRoommates
}
    `;